module.exports = __webpack_public_path__ + "img/keitaro-addition.en.70b7decc.jpg";